// src/helpers/userRole.js
import { useEffect, useMemo, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
// import app from "../firebase";
import {db as firestore} from "../firebase"
 
// Map aliases → canonical roles used by your UI.
function normalizeRole(r) {
  const v = (r ?? "").toString().trim().toLowerCase();
  if (["property manager", "property_manager", "pm", "mgr"].includes(v)) return "manager";
  if (["property owner", "property_owner", "owner"].includes(v)) return "landlord";
  return v;
}

function titleForRole(normRole) {
  switch (normRole) {
    case "landlord":
      return "Landlord Dashboard";
    case "manager":
      return "Manager Dashboard";
    case "agent":
      return "Agent Dashboard";
    case "owner":
      return "Property Owner Dashboard";
    default:
      return "Dashboard";
  }
}

/**
 * Subscribe to Firestore users/{uid}.userType and combine with any
 * role from Auth (currentUser.userType) as a fallback. Returns normalized role,
 * booleans, and title ready for rendering.
 */
export function useUserRole(currentUser) {
  const uid = currentUser?.uid || null;

  const [rawRole, setRawRole] = useState(null);
  const [roleLoaded, setRoleLoaded] = useState(false);

  useEffect(() => {
    if (!uid) {
      setRawRole(null);
      setRoleLoaded(true);
      return;
    }
    const ref = doc(firestore, "users", uid);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setRawRole(snap.exists() ? snap.data()?.userType ?? null : null);
        setRoleLoaded(true);
      },
      () => setRoleLoaded(true)
    );
    return () => unsub();
  }, [uid]);

  // Prefer Firestore; fall back to Auth role if present.
  const normRole = useMemo(() => {
    const source = rawRole ?? currentUser?.userType ?? "";
    return normalizeRole(source);
  }, [rawRole, currentUser?.userType]);

  const canCreate = normRole === "landlord";
  const dashboardTitle = useMemo(() => titleForRole(normRole), [normRole]);
  const isRoleReady = roleLoaded || !!currentUser?.userType;

  return {
    rawRole,
    normRole,
    canCreate,
    dashboardTitle,
    roleLoaded,
    isRoleReady,
  };
}
